import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'
import {DialogContentText} from 'material-ui/Dialog'
import {FormControl, FormHelperText} from 'material-ui/Form'
import Input, {InputLabel, InputAdornment} from 'material-ui/Input'
import Textfield from 'material-ui/TextField'

import {phone as styles} from '../styles'
import {phone as text} from '../text'
import LoadingButton from '../../../common/components/LoadingButton'

class Phone extends React.Component {

  render() {
    const {classes, tab, number, code, isLoading} = this.props
    return (
      <div>
        <Title classes={classes} text={text.title}/>
        {tab === 1 ?
          <div>
            <form>
              <DialogContentText>{text.body1}</DialogContentText>
              <FormControl fullWidth margin="dense" error={number.error.length > 0}>
                <InputLabel htmlFor="phone">{text.label1}</InputLabel>
                <Input
                  id="phone"
                  autoFocus={true}
                  startAdornment={<InputAdornment position="start" className={classes.number}
                                                  disableTypography={true}>+54&nbsp;</InputAdornment>}
                  type="tel"
                  value={number.value}
                  onChange={e => this.props.setPhoneNumber(e.target.value)}
                />
                <FormHelperText>{number.error}</FormHelperText>
              </FormControl>
              <Actions
                classes={classes}
                isLoading={number.isSaving}
                isDisabled={false}
                onClick={e => {
                  e.preventDefault()
                  this.props.sendSMS()
                }}
                text={'Enviar código'}
              />
            </form>
          </div>
          : null
        }
        {tab === 2 ?
          <div>
            <form>
              <DialogContentText>{text.body2}</DialogContentText>
              <Textfield
                autoFocus={true}
                label={text.label2}
                value={code.value}
                onChange={e => this.props.setCode(e.target.value)}
                margin="dense"
                fullWidth={true}
              />
              <TwoActions
                classes={classes}
                buttonOne={{
                  isLoading: false,
                  isDisabled: false,
                  onClick: () => this.props.setTab(1),
                  text: text.button2,
                }}
                buttonTwo={{
                  isLoading: code.isSaving || isLoading,
                  isDisabled: false,
                  onClick: e => {
                    e.preventDefault()
                    this.props.confirm()
                  },
                  text: text.button3,
                }}
              />
            </form>
          </div>
          : null
        }
      </div>
    )
  }

  static propTypes = {
    tab: PropTypes.number,
    setPhoneNumber: PropTypes.func.isRequired,
    number: PropTypes.shape({
      value: PropTypes.string,
      isSaving: PropTypes.bool,
      error: PropTypes.string,
    }),
    setCode: PropTypes.func.isRequired,
    code: PropTypes.shape({
      value: PropTypes.string,
      isSaving: PropTypes.bool,
      error: PropTypes.string,
    }),
    sendSMS: PropTypes.func.isRequired,
    confirm: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
  }
}

const Title = ({classes, text}) => (
  <div>
    <Typography variant="title" className={classes.dialogTitle}>{text}</Typography>
  </div>
)

const Actions = ({classes, isLoading, isDisabled, onClick, text}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="raised"
      color="primary"
      type="submit"
      onClick={onClick}
      disabled={isDisabled}
      isLoading={isLoading}
      className={classes.button}
    >
      {text}
    </LoadingButton>
  </div>
)

const TwoActions = ({classes, buttonOne, buttonTwo}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="flat"
      color="default"
      onClick={buttonOne.onClick}
      disabled={buttonOne.isDisabled}
      isLoading={buttonOne.isLoading}
      className={classes.button}
    >
      {buttonOne.text}
    </LoadingButton>
    <LoadingButton
      variant="raised"
      color="primary"
      type="submit"
      onClick={buttonTwo.onClick}
      disabled={buttonTwo.isDisabled}
      isLoading={buttonTwo.isLoading}
      className={classes.button}
    >
      {buttonTwo.text}
    </LoadingButton>
  </div>
)

export default withStyles(styles, {withTheme: true})(Phone)



// WEBPACK FOOTER //
// ./src/sections/missingInfo/components/phone.js